(() => {
  const sections = document.querySelectorAll('[data-vq-recent-section]');
  if (!sections.length) return;
  const key = 'vq_recent_products_v1';
  const safeParse = (value, fallback) => { try { return JSON.parse(value); } catch (_) { return fallback; } };

  sections.forEach((section) => {
    const dataNode = section.querySelector('[data-vq-current-product]');
    const grid = section.querySelector('[data-vq-recent-grid]');
    if (!dataNode || !grid) return;

    const current = safeParse(dataNode.textContent, null);
    if (!current || !current.handle) return;

    const stored = safeParse(localStorage.getItem(key) || '[]', []);
    const previous = stored.filter((item) => item && item.handle && item.handle !== current.handle).slice(0, 4);

    previous.forEach((item) => {
      const link = document.createElement('a');
      link.className = 'vq-recent-card';
      link.href = item.url || `/products/${item.handle}`;

      const media = document.createElement('div');
      media.className = 'vq-recent-card__media';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const body = document.createElement('div');
      body.className = 'vq-recent-card__body';
      const title = document.createElement('p');
      title.className = 'vq-recent-card__title';
      title.textContent = item.title || item.handle;
      const price = document.createElement('span');
      price.className = 'vq-recent-card__price';
      price.textContent = item.price || '';
      body.append(title, price);
      link.append(media, body);
      grid.appendChild(link);
    });

    if (previous.length) section.hidden = false;

    const next = [current, ...stored.filter((item) => item && item.handle !== current.handle)].slice(0, 8);
    try { localStorage.setItem(key, JSON.stringify(next)); } catch (_) {}
  });
})();